import { render, staticRenderFns } from "./user-contact-main.vue?vue&type=template&id=dbb9e32e&"
import script from "./user-contact-main.vue?vue&type=script&lang=js&"
export * from "./user-contact-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports